import { TimeRange } from "../../common/component/DateRangeSelector"
import { IFilterDto, IPagination, TFieldDefinition } from "../../common/model/Core.model"
import { IAssetNestedDto } from "../asset/Asset.model"
import { IClientNestedDto } from "../client/Client.model"
import { IContactDto } from "../contact/Contact.model"
import { IContractNestedDto } from "../contract/Contract.model"
import { ITicketReference, PriorityLevel } from "../helpdesk/ticket/Ticket.model"
import { IAttachment } from "../media/Media.model"
import { IMetadata } from "../report-metadata/ReportMetadata.model"

export interface IReportDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  client: IClientNestedDto //IReportClient
  asset: IAssetNestedDto //IReportAsset
  reportMetadata: IReportMetadata
  contract?: IContractNestedDto //IReportContract
  id: string
  sequence: string
  status: string
  serviceDesk: boolean
  startedAt: string
  endedAt: string
  countryCode: string
  country: string
  address: string
  latitude: string
  longitude: string
  visitType: string
  category: string
  frequencyCode: string
  frequency: string
  contacts: IContactDto[]
  technicians: IContactDto[]
  metadata: IMetadata
  shared: boolean
  sharedLogs: IReportShareLogDto[]
  ticketReferences?: ITicketReference[]
  workOrderRequest?: IReportWorkOrderRequestDto
  totalAttachment: number
}

export interface IReportCreateRequestDto {
  clientId: string
  assetId: string
  reportMetadataId: string
  contractId?: string
  status: string
  serviceDesk: boolean
  startedAt?: string
  endedAt?: string
  countryCode?: string
  country?: string
  address: string
  latitude?: string
  longitude?: string
  visitType: string
  category: string
  frequencyCode: string
  frequency: string
  contacts: IContactDto[]
  technicians: IContactDto[]
  metadata: IMetadata
  attachments: IAttachment[]
  workOrderRequest?: IReportWorkOrderRequestDto
}

export interface IReportUpdateRequestDto {
  id: string
  status?: string
  serviceDesk?: boolean
  startedAt: string
  endedAt: string
  countryCode?: string
  country?: string
  address?: string
  latitude?: string
  longitude?: string
  visitType?: string
  category?: string
  frequencyCode?: string
  frequency?: string
  contacts?: IContactDto[]
  technicians?: IContactDto[]
  metadata: IMetadata
  attachments: IAttachment[]
  workOrderRequest?: IReportWorkOrderRequestDto
}

export interface IReportSearchRequestDto {
  organizationId?: string
  pagination?: IPagination
  field?: TFieldDefinition
  filters?: IFilterDto[]
  timeRange?: TimeRange
}

// export interface IReportClient {
//   id: string
//   sequence: string
//   displayName: string
//   sector: string
// }

// export interface IReportAsset {
//   id: string
//   sequence: string
//   displayName: string
//   family: string
//   familyCode: string
//   area: string
//   areaCode: string
//   brand: string
//   model: string
//   serial: string
// }

// export interface IReportContract {
//   id: string
//   sequence: string
//   status: string
//   startDate: string
//   endDate: string
//   documentType: string
//   serviceType: string
//   serviceFrequency: string
//   serviceResponseTime?: string
//   serviceAgreement?: string
//   comments?: string
// }

export interface IReportMetadata {
  id: string
  sequence: string
  familyCode: string
  family: string
  areaCode: string
  area: string
}

export interface IReportShareLogDto {
  createdAt: string
  createdBy: string
  from: string
  to: string[]
}

export interface IReportWorkOrderLineRequestDto {
  workOrderTypeCode: IWorkOrderLineType
  workOrderType: string
  details: string
}

export interface IReportWorkOrderRequestDto {
  reportedBy: string
  priorityCode?: PriorityLevel
  priority?: string
  observations?: string
  lines: IReportWorkOrderLineRequestDto[]
  attachments: IAttachment[]
}

export enum IWorkOrderLineType {
  SPARE_PART = 'SPARE_PART',
  MAINTENANCE = 'MAINTENANCE',
  OTHER = 'OTHER',
}

export enum IReportStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  ACCEPTED = 'ACCEPTED',
  CLOSED = 'CLOSED',
}

export enum IReportFilter {
  CLIENT_HASH = 'CLIENT_HASH',
  CLIENT_ID = 'CLIENT_ID',
  CLIENT = 'CLIENT',
  ASSET_HASH = 'ASSET_HASH',
  ASSET_ID = 'ASSET_ID',
  GUI = 'GUI',
  FAMILY = 'FAMILY',
  AREA = 'AREA',
  BRAND = 'BRAND',
  MODEL = 'MODEL',
  SERIAL = 'SERIAL',
  METADATA_HASH = 'METADATA_HASH',
  METADATA_ID = 'METADATA_ID',
  CONTRACT_HASH = 'CONTRACT_HASH',
  CONTRACT_ID = 'CONTRACT_ID',
  HASH = 'HASH',
  ID = 'ID',
  STATUS = 'STATUS',
  CATEGORY = 'CATEGORY',
  FREQUENCY = 'FREQUENCY',
  VISIT_TYPE = 'VISIT_TYPE',
  ADDRESS = 'ADDRESS',
  SHARED = 'SHARED',
}

export interface IReportDownloadRequestDto {
  id: string
  header: boolean
  i18n: string
  timeZone: string
  renew?: boolean
}

export interface IReportDownloadResponseDto {
  organizationId: string
  id: string
  bucket: string
  path: string
  file: string
  contentType: string
  url: string
}

export interface IReportShareRequestDto {
  id: string
  to: string[]
  i18n: string
  timeZone: string
  renew?: boolean
  comments?: string
}